import { ContentModal } from 'sma.common/components/modals';

const croppie = require('vendor/croppie');
const baseModalTempl = require('sma.common/components/partials/image_uploader/base.mustache');


class FileUploader extends Backbone.View {
	get events() {
		return ({
			change: 'newImageUploaded',
		});
	}

	initialize(config) {
		this.setElement(config.inputElement);

		this.imageContainer = config.imageContainer;
		this.existingImageURL = config.existingImageURL || '';

		this.render();
	}

	newImageUploaded() {
		this.imageContainer.empty();

		const fileReader = new FileReader();

		// Get DOM element from jquery object to access .files
		const selectedImage = this.$el.get(0).files[0];

		fileReader.onload = (e) => {
			this.renderImage(e.target.result);
		};

		$.when(this.updateInputText(selectedImage.name)).done(() => {
			if (selectedImage && selectedImage.size < 10000000) {
				fileReader.readAsDataURL(selectedImage);
			}
		});
	}

	updateInputText(imageName) {
		this.imageContainer.prepend($('<div />').html(imageName));
	}

	render() {
		if (this.existingImageURL) {
			this.renderImage(this.existingImageURL);
		}
	}

	renderImage(imgURL) {
		const img = $('<img class="img-md">');
		if (imgURL.indexOf('text/csv') === -1) {
			img.attr('src', imgURL);
			img.appendTo(this.imageContainer);
		}
	}
}

class ImageCropper extends Backbone.View {
	initialize(config) {
		this.setElement(config.wrapper);

		this.inputField = config.inputField;
		this.onCrop = config.onCropHandler;

		this.events = this.events || {};
		const eventKey = `change ${this.inputField}`;
		this.events[eventKey] = 'fileUploaded';
		this.delegateEvents();
	}

	clearField() {
		$(this.inputField).val('');
	}

	fileUploaded(e) {
		const target = e.currentTarget;
		const content = baseModalTempl();
		const uploadModal = new ContentModal(
			content, {
				destroyOnClose: true,
				title: gettext('Create Profile Photo'),
				buttons: [
					{
						label: gettext('Cancel'),
						cls: 'btn btn-link',
						handler: (modal) => {
							modal.hide();
						},
					},
					{
						label: gettext('Save'),
						cls: 'btn btn-primary',
						handler: (modal) => {
							$('#sma-js-picture-preview').croppie('result', {
								type: 'canvas',
								size: { width: 512, height: 512 },
							}).then((croppedImg) => {
								this.onCrop(croppedImg);
							});
							modal.hide();
						},
					},
				],
				destroyCallback: () => {
					this.clearField();
				},
			},
		);

		const imagePreview = $('#sma-js-picture-preview').croppie({
			enableExif: true,
			viewport: {
				width: 512,
				height: 512,
				type: 'square',
			},
			boundary: {
				width: 500,
				height: 500,
			},
		});

		if (target.files && target.files[0]) {
			const reader = new FileReader();

			reader.onload = (event) => {
				imagePreview.croppie('bind', {
					url: event.target.result,
				});
			};

			reader.readAsDataURL(target.files[0]);
		}

		uploadModal.show();
	}
}

module.exports = {
	FileUploader,
	ImageCropper,
};
